<output class="enum-output" #outputEl>
    <span class="enum-item" [class.enum-item--with-icon]="value.icon" *ngFor="let value of list; trackBy: trackByFn">
        <ng-container *ngIf="value.icon; else onlyText">
            <svg-image class="enum-item-icon" [name]="value.icon"></svg-image>
            <span class="enum-item-text">{{ value.label }}</span>
        </ng-container>
        <ng-template #onlyText>
            <span class="enum-item-text">{{ value }}</span>
        </ng-template>
    </span>
    <span class="rest-items" [attr.data-selected-count]="enumItems.size" [ngClass]="{visible: otherCount}">
        <span class="enum-item-text">{{ getRestString() }}</span>
    </span>
</output>
